export const ApiQueryKey = {
	admins: 'admins',

	priceGroups: 'price-groups',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	creatorProductModules: 'creator-product-modules',
	projects: 'projects',
	presets: 'presets',

	productModuleCollections: 'product-module-collections',
	productModules: 'product-modules',
	assets: 'assets',
	content: 'content',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
